import { EnvironmentProviders, Provider, inject, provideEnvironmentInitializer } from '@angular/core';
import { ApiService } from 'app/core/api/api.service';

export const provideApi = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideEnvironmentInitializer(() => inject(ApiService)),
    ];
};
